<div class="common__suggestion--view w-full mt-3 h-full" *ngIf="suggestionData?.length">
  @if(suggestionData[0]?.userData?.length || suggestionData[1]?.vaultFormTypeData?.length){
  <div class="app__centered-item justify-between w-full mb-3">
    <div class="app__form--attribute--title app__centered-item text-sm text-[#18191C] font-semibold gap-1">
      <span>{{ title }}</span>
      <span class="text-[#25508E] font-bold">({{ suggestionData[0]?.userData?.length + suggestionData[1]?.vaultFormTypeData?.length }})</span>
    </div>
    @if(isFromFamilyTree){
    <div
      class="app__form--attribute--title flex items-center hover:cursor-pointer"
      (click)="selectSuggestionItem(suggestionData[0]?.userData, 'user')"
    >
      <div class="text-[#25508E] text-sm underline">Add All</div>
    </div>
    }
  </div>
  } @if(type == "Financial Accounts" || type == "linked_exchange_wallets" ){
  <button
    [ngClass]="{
      'bg-[#effff7] text-[#1aa140] border-[#1aa140] hover:bg-[#30c279] hover:text-[#ffffff] hover:cursor-pointer': !disableOwners,
      'bg-[#F3F2F1] text-[#B1ACB0] border-[#B1ACB0]': disableOwners
    }"
    style="min-height: 48px; line-height: 48px; border: 1px solid #1aa140"
    (click)="addMxData()"
    class="app__btn--primary mt-0 mb-3 p-0 hover:cursor-pointer ng-star-inserted"
    (mouseover)="hovered = true"
    (mouseleave)="hovered = false"
  >
    <img
      *ngIf="!disableOwners"
      [src]="hovered ? '../../../../assets/images/mx-Icon.svg' : '../../../../assets/images/mx_icon-wt.svg.svg'"
      class="mt-4 mr-2"
    />

    Import Accounts Directly (Via API)
  </button>
  }

  <div
    class="flex flex-wrap w-full overflow-y-auto gap-3"
    [ngClass]="type == 'linked_financial_accounts' || type == 'linked_exchange_wallets' ? 'max-h-[60%]' : 'max-h-[80%]'"
    [class]="inlineComponent && !isFromFamilyTree ? 'pr-2' : ''"
  >
    <ng-container *ngFor="let suggestionItems of suggestionData">
      <ng-container *ngIf="suggestionItems?.type == 'user' && suggestionItems?.userData?.length">
        <span
          *ngFor="let user of suggestionItems.userData"
          class="app__discovery--selected--option h-[66px] p-0 px-4 overflow-y-hidden"
          [ngClass]="{
            'workspace__mobile---member--view px-[18px]': isFromFamilyTree
          }"
        >
          <ngx-avatars
            class="custom-nx-avatar"
            [size]="isFromFamilyTree ? 44 : 52"
            [src]="user?.user_profile_image_url ?? user?.profile_image_url ?? user?.form_profile_image_url"
            [name]="user?.name | titlecase"
            [round]="true"
            initialsSize="2"
            cornerRadius="100"
          ></ngx-avatars>
          <span
            class="w-[80%] app__form--attribute--title font-semibold text-sm text-[#515765] mt-[18px]"
            [matTooltip]="(screenWidth >= 1200 && user?.name?.length > 34) || (screenWidth < 1200 && user?.name?.length > 12) ? user.name : ''"
            matTooltipPosition="above"
          >
            <p class="text-sm font-semibold">{{ user?.name | truncateStrPipe : (screenWidth < 1200 ? 12 : 34) }}</p>
            <p class="font-medium text-[12px] text-[#707070] mt-[-10px]">{{ user?.relationship_name }}</p>
          </span>
          <div class="app__centered-item justify-end">
            <button
              class="app__btn--primary sm:py-[6px] py-[6px] px-5 m-0 rounded-lg text-[12px]"
              [disableRipple]="true"
              (click)="selectSuggestionItem(user, suggestionItems.type)"
            >
              <span> Add </span>
            </button>
          </div>
        </span>
      </ng-container>
      <ng-container *ngIf="suggestionItems?.type == 'entity' && suggestionItems?.vaultFormTypeData?.length">
        <span *ngFor="let form of suggestionItems.vaultFormTypeData" class="app__discovery--selected--option h-[66px] p-0 px-4 overflow-y-hidden">
          <span>
            <img
              src="{{ getFormData(form?.id) ? getFormData(form?.id ? form?.id : 57)[0]?.image : null }}"
              class="w-[52px] h-[52px] rounded box-border"
            />
          </span>
          <span
            class="w-[55%] app__form--attribute--title font-semibold text-sm text-[#515765]"
            [matTooltip]="(screenWidth >= 1200 && form?.type?.length > 34) || (screenWidth < 1200 && form?.type?.length > 12) ? form.type : ''"
            matTooltipPosition="above"
          >
            {{ (form?.displayType ? form.displayType : form.type) | truncateStrPipe : (screenWidth < 1200 ? 12 : 34) }}
          </span>
          <div class="app__centered-item justify-end">
            @if(form?.linked){
            <div
              class="app__form--attribute--title w-fit h-fit bg-[#EAFFF0] border-solid border-[0.5px] border-[#1AA140] text-[#1AA140] rounded font-semibold text-xs px-2 py-1 mr-2"
            >
              Linked
            </div>
            }
            <button
              class="min-w-fit px-3 py-2 rounded border-solid border border-[#53565b33] hover:border-[#25508E]"
              (click)="$event.stopPropagation()"
              mat-button
              [matMenuTriggerFor]="addTemplateSuggestion"
              #suggestionMenu="matMenuTrigger"
              [disableRipple]="true"
              (menuOpened)="(suggestionMenu.menuOpen)"
              (menuClosed)="(suggestionMenu.menuOpen)"
              style="box-shadow: 0px 2px 9px 0px #00000008"
            >
              <span class="app__centered-item w-6 h-6 rounded-full bg-[#ebf0fa]"
                ><span class="material-icons text-[#25508e] text-[13.5px] font-medium">search</span></span
              >
              <span class="app__form--attribute--title text-[12px] font-semibold leading-[17px] text-center text-[#25508e] ml-2">
                Link existing
              </span>
            </button>
            <button
              mat-button
              class="min-w-fit px-3 py-2 ml-2 rounded border-solid border border-[#53565b33] hover:border-[#25508E]"
              [disableRipple]="true"
              (click)="addNewForm(form)"
              style="box-shadow: 0px 2px 9px 0px #00000008"
            >
              <span class="app__centered-item w-6 h-6 rounded-full bg-[#ebf0fa]">
                <span class="material-icons text-[#25508e] text-[13.5px] font-medium">add</span></span
              >
              <span class="app__form--attribute--title text-[12px] font-semibold leading-[17px] text-center text-[#25508e] ml-2"> Add new </span>
            </button>
          </div>
          <mat-menu #addTemplateSuggestion="matMenu" yPosition="below" xPosition="after" class="attached-dropdown-menu-panel">
            <div class="w-[294px] h-auto bg-white box-border m-0 py-2" appClickOutside>
              <form>
                <mat-form-field appearance="fill" class="h-[32px] px-3 bg-white" style="width: -webkit-fill-available" id="myfield">
                  <mat-icon class="text-xl text-[#898F9E] mt-[-10px]" matSuffix>search </mat-icon>
                  <input
                    class="app__between--justified--content app__form--attribute--title app__solid--border border-[#d3dce8] rounded-[3px] text-sm font-normal"
                    #fileInput
                    type="text"
                    matInput
                    [matAutocomplete]="auto"
                    [formControl]="templateSaerchFormControl"
                    placeholder="Search"
                  />
                  {{ fileInput.focus() }}
                </mat-form-field>

                <p
                  class="app__form--attribute--title font-medium text-[#b0aaaa] text-sm px-3 mt-7"
                  *ngIf="(form.entityData | addFilterReportDataList : selectedData : templateSaerchFormControl.value)?.length == 0"
                >
                  No results found
                </p>
                <div
                  class="w-full h-auto max-h-[216px] overflow-y-auto mt-5"
                  *ngIf="(form.entityData | addFilterReportDataList : selectedData : templateSaerchFormControl.value)?.length"
                >
                  <div
                    class="flex items-start hover:cursor-pointer hover:bg-[#010b1805]"
                    *ngFor="let entity of form.entityData | addFilterReportDataList : selectedData : templateSaerchFormControl.value"
                    (click)="selectSuggestionItem(entity, suggestionItems.type)"
                  >
                    <div class="flex text-center px-3 py-[7px]">
                      <span class="app__centered-item box-border" *ngIf="entity.profile_image_url">
                        <ngx-avatars
                          class="custom-nx-avatar"
                          size="24"
                          [src]="entity?.profile_image_url ?? entity?.form_profile_image_url"
                          [name]="entity?.name | titlecase"
                          [round]="true"
                          initialsSize="2"
                          cornerRadius="100"
                        ></ngx-avatars>
                      </span>
                      <span class="app__centered-item box-border" *ngIf="!entity.profile_image_url">
                        <img
                          src="{{
                            getFormData(entity?.vault_form_id) ? getFormData(entity?.vault_form_id ? entity?.vault_form_id : 57)[0]?.image : null
                          }}"
                          class="w-[24px] h-[24px] rounded box-border"
                        />
                      </span>
                      <span
                        class="app__form--attribute--title app__centered-item font-semibold text-[12px] ml-3 left-6"
                        matTooltip="{{ entity?.name?.length > 35 ? entity.name : '' }}"
                      >
                        <span> {{ entity.name | titlecase | truncateStrPipe : 30 }} </span>
                      </span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </mat-menu>
        </span>
      </ng-container>
    </ng-container>
  </div>
</div>
